/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Components {
    "use strict";

    import IComponentOptions = angular.IComponentOptions;
    import IScopeService = angular.IScope;
    import IModalService = Meevo.Components.Modal.IModalService;
    import ScanOpeningContainer = Meevo.Model.ScanOpeningContainer;
    import Client = Meevo.Model.Client;
    import ClientTypeEnum = Meevo.Model.ClientTypeEnum;

    export class SuggestionsResults implements IComponentOptions {
        templateUrl = "app/components/suggestions/suggestionsResults.component.html";
        bindings: any = {

        }
        controller = class SuggestionsResultsController {
            public suggestions: ScanOpeningContainer[] = null;
            public selectedSuggestion: ScanOpeningContainer = null;
            public payingClient: any = null;
            public payingClientType: ClientTypeEnum = ClientTypeEnum.Client;
            public notes: string = null;
            public processingSelectedAppointmentDateTime: boolean = false;

            static $inject = ['$scope', 'meevo.components.suggestionsService', 'meevo.components.modal.ModalService', '$rootScope'];
            constructor(private $scope: IScopeService, private suggestionsService: ISuggestionsService, private modalService: IModalService, private rootScope: ng.IRootScopeService) { }

            $onInit(): void {
                this.suggestions = this.suggestionsService.suggestions;
                this.payingClient = this.suggestionsService.payingClient;
            }

            $postLink(): void {
                setTimeout(() => {
                    this.rootScope.$broadcast(Meevo.Components.Common.Messages.TYPEAHEAD_FOCUS, 'suggestionsPayingClient');
                }, 800);
            }

            public close() {
                this.modalService.hide();
            }

            public select(opening: ScanOpeningContainer): void {
                // prevent this function from firing off twice
                if (this.processingSelectedAppointmentDateTime)
                    return;
                this.processingSelectedAppointmentDateTime = true;
                this.suggestions.forEach(suggestion => {
                    (<any>suggestion).isSelected = false;
                });
                (<any>opening).isSelected = true;
                this.selectedSuggestion = opening;
                this.processingSelectedAppointmentDateTime = false;
            }

            public book(): void {
                this.suggestionsService.bookFromSuggestion(this.selectedSuggestion, this.payingClient, this.payingClientType, this.notes).then(
                    () => {
                        this.close();
                    });
            }

            public onClientSelectionChanged(client) {
                if (!this.payingClient && client) {
                    this.payingClient = client;
                }
                else if (this.payingClient && client && this.payingClient.id == client.id) {
                    this.payingClient.firstName = client.firstName;
                    this.payingClient.lastName = client.lastName;
                    this.payingClient.middleName = client.middleName;
                    this.payingClient.displayName = client.displayName;
                }

                this.payingClientType = ClientTypeEnum.Client;
                if (this.payingClient) {
                    this.suggestionsService.checkIntelliSuggestion(this.payingClient, this.payingClientType, this.notes)
                        .then(response => {
                            this.suggestions = this.suggestionsService.suggestions;
                            this.rootScope.$broadcast(Meevo.Components.Common.Messages.SUGGESTIONS_CLIENT_ADDEDIT_CALLBACK, null);
                        });
                }
                else {
                    this.suggestionsService.payingClient = this.payingClient;
                }
            }

            public onAnonymousClientTypeChanged() {
                const anonymousDisplayName = ClientTypeEnum[this.payingClientType].replace("Anonymous", "Anonymous ");
                this.payingClient = {
                    id: undefined,
                    displayName: anonymousDisplayName
                };
                this.suggestionsService.payingClient = this.payingClient;
            }
        }
    }

    angular.module('meevo.components.common')
        .component('suggestionsResults', new SuggestionsResults());
}
